import React, { useEffect, useState }                               from 'react';
import { Spinner }                                                  from 'react-bootstrap';
import { useDispatch, useSelector }                                 from 'react-redux';

import AuthoritiesService                                           from '../../../services/AuthoritiesService';

import { MSG_DELETE, MSG_NOT_REVERT_OPERATION }                     from '../../../constants/messages';
import { ACTION_EDIT, ACTION_DELETE, ACTION_ENABLE }                from '../../extras/actionTypes';
import { ConfirmDeleteMessage }                                     from '../../extras/toastMessages';

import TableList                                                    from '../../layout/TableList';
import QuickFilter                                                  from '../../layout/QuickFilter';

import { listJudgesAction, editJudgesAction, deleteJudgesAction }   from '../../../actions/judgesActions';
import { enableJudgesAction }                                       from '../../../actions/judgesActions';

import { JUECES_CREAR, JUECES_ELIMINAR, JUECES_MODIFICAR }          from '../../../data/objects';
import { PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR }                from '../../../data/objects';




const JudgeList = props => {


    // ==========================================================================================
    // DECLARACIONES ----------------------------------------------------------------------------
    // ==========================================================================================
    
    const params = { sort: 'apellido:asc,nombre:asc' }
    
    // Tomo los props
    const { handleOpen, handleClose } = props;
    
    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Inicializo el state local
    const [ data, setData ] = useState(null);
    


    // ==========================================================================================
    // CARGA DE VALORES -------------------------------------------------------------------------
    // ==========================================================================================
    
    // Traigo el store de persona tipos
    const judgesLoading = useSelector( state => state.judges.loading );
    const judges = useSelector( state => state.judges.judges );
    const authorities = useSelector(state => state.auth.authorities);
    
    
    
    // ==========================================================================================
    // FUNCIONES --------------------------------------------------------------------------------
    // ==========================================================================================
    
    // Manjo la eliminación
    const handleDelete = item => {
        // Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteJudgesAction(item) )
            }
        )
    }

    // Manejo de la edición
    const handleEdit = item => {
        // Llamo al dispatch de edición
        dispatch( editJudgesAction(item, handleOpen) );
    }

    // Manejo la habilitación
    const handleEnable = item => {
        dispatch( enableJudgesAction(item) );
    }

    // Inicializo las cabeceras
    const headers = [
        {   name: 'Apellido',
            width: null,
            style: null,
            field: 'apellido'
        },
        {   name: 'Nombres',
            width: null,
            style: null,
            field: 'nombre',
        },
        {   name: 'Email',
            width: null,
            style: null,
            field: 'email',
        },
        {   name: 'Menores',
            width: null,
            style: 'text-center',
            field: 'menor',
            isBoolean: true
        },
        {   name: 'Ejecución',
            width: null,
            style: 'text-center',
            field: 'ejecucion',
            isBoolean: true
        },
        {   name: 'Ofiju',
            width: null,
            style: 'text-center',
            field: 'ofiju',
            subfield: 'nombre'
        },
        {   name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {   name: ACTION_ENABLE,
                    handle: handleEnable,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, JUECES_CREAR)
                },
                {   name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, JUECES_MODIFICAR)
                },
                {   name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, JUECES_ELIMINAR)
                }
            ]
        }
    ];

    // Cargo los datos
    useEffect(() => {
        // Verifico si hay datos
        if(judges)
        {   // Seteo los datos
            setData(judges);
        }
        else
        {   // Si no hay datos, debo cargarlo
            dispatch( listJudgesAction(params) );
        }
    }, [judges]);
    
    
    
    // ==========================================================================================
    // RENDERIZO --------------------------------------------------------------------------------
    // ==========================================================================================
    
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <QuickFilter
                            initialData={judges}
                            headers={headers}
                            setData={setData}
                        />
                        {   judgesLoading 
                                ? 
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only">Cargando...</span>
                                    </Spinner>
                                : 
                                null
                        }
                        {   data 
                                ? 
                                    <TableList
                                        prefix="judge"
                                        headers={headers}
                                        items={data}
                                        state={{
                                            field: 'activo',
                                            disabledClass: 'table-danger',
                                            disabledValue: 0,
                                            hideActions: true
                                        }}
                                    />
                                : 
                                    null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JudgeList;